<template>
	<div ref="galleryWrapper"
		class="galleryWrapper">
		<VueGallery :images="imgurApi.imgUrlsTotal" :index="index" @close="index=null"></VueGallery>

		<div v-show="loading" class="loading">
			<div class="looper"></div>
			<span v-show="error">There seems to be an issue connecting to my image storage.</span>
		</div>

		<waterfall v-show="!loading"
					class="waterfall" 
					:line="'h'" 
					:line-gap="200" 
					:watch="imgTotal" 
					:align="'left'" 
					:auto-resize="true">
				<waterfall-slot class="item"
					v-for="(image, index) in imgTotal"
					:width="image.scaledWidth"
					:height="image.scaledHeight"
					:order="index"
					:key="image.key">
					<img class="thumbs"
						@click="setKey(image.key)"
						:src="image.link">
				</waterfall-slot>
		</waterfall>
	</div>
</template>

<script>
	import VueGallery from 'vue-gallery';
	import Waterfall from 'vue-waterfall/lib/waterfall';
	import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot';

	export default {
		name: "ImageGallery",
		components: { VueGallery, Waterfall, WaterfallSlot },
		dependencies: ["imgurApi"],
		created(){
			this.imgurApi.getAlbum()
				.then(()=>{
					this.updateList();
				});
		},
		mounted(){
			this.imgurApi.setDom(this.$refs);
			this.updateList();
		},
		data(){
			return {
				index: null,
				imgTotal: [],
				loading:true,
				error:null
			}
		},
		methods : {
			killBuffer:function(){
				clearInterval(this.interval);
			},
			isBufferLoading:function(){
				return this.interval !== null;
			},
			setKey:function(key){
				this.index=key;
			},
			updateList:function(){
				this.imgurApi.getNewGroup()
					.then((res)=>{
						this.imgTotal = res;
						this.loading = false;
						this.error = false;
					})
					.catch((err)=>{
						this.loading = true;
						this.error = (err!=="loading");
					});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.galleryWrapper{
		height:100vh;
		width: 100vw;
		overflow: hidden;
	}

	.waterfall{
		width: 150vw;
		height: 100vh;
		margin: -2vw;
		overflow: hidden;


		.item {
			opacity: 1;
			width: 200px;
			overflow: hidden;
			transform: scale(1);

			.thumbs{
				overflow: hidden;
				width: 100%;
				height: 100%;
			}
			&:hover{
				box-shadow: rgba(0,0,0,0.72) -20px -20px 40px 15px;
				transform: translate3d(0px, 0px, 200px);
				transform: scale(1.7);
				z-index:100;
			}
		}
	}

	.loading{
		width: 100%;
		height: 100%;
		.looper{
			margin: auto;
			position: relative;
			width: 10px;
			height: 10px;
			background: black;
			border-radius: 50px;
			top: 50%;
			animation: shrinkGrow 1s infinite;
		}
	}

	@keyframes shrinkGrow{
		0% { transform: scale(1); background: black; }
		50% { transform: scale(7); background: white; }
		100% { transform: scale(1); background: black; }
	}
</style>